export const daysOfWeek = [
  {
    label: "شنبه",
    key: "Saturday",
  },
  {
    label: "یکشنبه",
    key: "Sunday",
  },
  {
    label: "دوشنبه",
    key: "Monday",
  },
  {
    label: "سه شنبه",
    key: "Tuesday",
  },
  {
    label: "چهار شنبه",
    key: "Wednesday",
  },
  {
    label: "جمعه",
    key: "Friday",
  },
  {
    label: "پنجشنبه",
    key: "Thursday",
  },
];
export const cities = [
  {
    name: "کرج",
    status: "به زودی",
    imgSrc: "kar",
    id: false,
  },
  {
    name: "تبریز",
    status: "به زودی",
    imgSrc: "tabriz",
    id: false,
  },
  {
    name: "اصفهان",
    status: "به زودی",
    imgSrc: "esfahan",
    id: false,
  },
  {
    name: "شیراز",
    status: "به زودی",
    imgSrc: "shiraz",
    id: false,
  },
  {
    name: "ساری",
    status: "به زودی",
    imgSrc: "sari",
    id: false,
  },
  {
    name: "قم",
    status: "به زودی",
    imgSrc: "qom",
    id: false,
  },
  {
    name: "مشهد",
    status: "فعال",
    imgSrc: "ms",
    id: 491,
    route: "mashhad",
  },
  {
    name: "شاهرود",
    status: "فعال",
    imgSrc: "shahrod",
    id: 634,
    route: "shahrud",
  },
  {
    name: "نیشابور",
    status: "فعال",
    imgSrc: "ne",
    id: 502,
    route: "neyshabur",
  },
  {
    name: "تهران",
    status: "فعال",
    imgSrc: "tehran",
    id: 329,
    route: "tehran",
  },
];
export const citiesReserves = {
  pool: {},
  gym: {},
  salon: {},
};
export const routes = [
  {
    name: "مدیریت اشخاص",
    key: "personMnanage",
  },
  {
    name: "لیست نقش ها",
    key: "RolesList",
  },
  {
    name: "ایجاد نقش",
    key: "RoleCreate",
  },
  {
    name: "ویرایش نقش",
    key: "RoleEdit",
  },
  {
    name: " لیست کارمندان",
    key: "EmployeeList",
  },
  {
    name: "ایجاد کارمندان",
    key: "EmployeeCreate",
  },
  {
    name: "ویرایش کارمندان",
    key: "EmployeeEdit",
  },
  {
    name: "لیست پیمان کاران",
    key: "ContractorList",
  },
  {
    name: "ایجاد پیمان کاران",
    key: "ContractorCreate",
  },
  {
    name: "ویرایش پیمان کاران",
    key: "ContractorEdit",
  },
  {
    name: "تعریفات پایه",
    key: "BasicDefines",
  },
  {
    name: "لیست پارامتر ها",
    key: "ListParametrs",
  },
  {
    name: "ایجاد پارامتر ها",
    key: "CreateParametrs",
  },
  {
    name: "ویرایش پارامتر ها",
    key: "EditParamers",
  },
  {
    name: "لیست گروه کارگران",
    key: "ListWorkerGroup",
  },
  {
    name: "ایجاد گروه کارگران",
    key: "CreateWorkerGroup",
  },
  {
    name: "ویرایش گروه کارگران",
    key: "EditWorkerGroup",
  },
  {
    name: "لیست اضافات و کسورات",
    key: "ListClassifiction",
  },
  {
    name: "ایجاد اضافات و کسورات",
    key: "CreateClassifiction",
  },
  {
    name: "ویرایش اضافات و کسورات",
    key: "EditClassifiction",
  },
  {
    name: "لیست گروه خدمات",
    key: "ListServiceGroup",
  },
  {
    name: "ایجاد گروه خدمات",
    key: "CreateServiceGroup",
  },
  {
    name: "ویرایش گروه خدمات",
    key: "EditServiceGroup",
  },

  {
    name: "لیست آیتم جریمه",
    key: "ListFualtItems",
  },
  {
    name: "ایجاد آیتم جریمه",
    key: "CreateFualtItems",
  },
  {
    name: "ویرایش آیتم جریمه",
    key: "EditFualtItems",
  },
  {
    name: "منابع پیمان",
    key: "PeymanResource",
  },
  {
    name: "لیست آیتم پیمان",
    key: "ListPeymanItem",
  },
  {
    name: "ایجاد آیتم پیمان",
    key: "CreatePeymanItem",
  },
  {
    name: "ویرایش آیتم پیمان",
    key: "EditPeymanItem",
  },
  {
    name: "لیست  پیمان",
    key: "ListPeyman",
  },
  {
    name: "ایجاد  پیمان",
    key: "CreatePeyman",
  },
  {
    name: "ویرایش  پیمان",
    key: "EditPeyman",
  },
  {
    name: "نظرات",
    key: "Watch",
  },
  {
    name: "ثبت جرایم روزانه",
    key: "CreateFaultDay",
  },
];
